import { render, staticRenderFns } from "./ForumStatsContainer.vue?vue&type=template&id=7125df56&scoped=true&"
import script from "./ForumStatsContainer.vue?vue&type=script&lang=js&"
export * from "./ForumStatsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ForumStatsContainer.vue?vue&type=style&index=0&id=7125df56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7125df56",
  null
  
)

export default component.exports